const WIDTH_KEY = 'couplespace:sidebar-width';
const COLLAPSED_KEY = 'couplespace:sidebar-collapsed';

export const SIDEBAR_DEFAULT_WIDTH = 220;
export const SIDEBAR_MIN_WIDTH = 160;
export const SIDEBAR_MAX_WIDTH = 420;
export const SIDEBAR_COLLAPSED_RAIL = 36;

function readStorage(key: string): string | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(key);
}

function writeStorage(key: string, value: string): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(key, value);
  }
}

export function getSidebarWidth(): number {
  const raw = readStorage(WIDTH_KEY);
  if (!raw) {
    return SIDEBAR_DEFAULT_WIDTH;
  }
  const parsed = Number.parseInt(raw, 10);
  if (Number.isNaN(parsed)) {
    return SIDEBAR_DEFAULT_WIDTH;
  }
  return Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, parsed));
}

export function setSidebarWidth(width: number): void {
  writeStorage(WIDTH_KEY, String(Math.round(width)));
}

export function getSidebarCollapsed(): boolean {
  return readStorage(COLLAPSED_KEY) === '1';
}

export function setSidebarCollapsed(collapsed: boolean): void {
  writeStorage(COLLAPSED_KEY, collapsed ? '1' : '0');
}
